import { EventType } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/event_pb';
import { queryOptions } from '@tanstack/react-query';
import { ReservoirPredictionsAvailabilityModel } from '~/pages/System/models/ReservoirPredictionsAvailabilityModel';
import { listEvents } from '~/services/api/fetchers/events.api';

export const availableReservoirPredictionsQuery = ({
  resourceName,
}: {
  resourceName: string;
}) =>
  queryOptions({
    queryKey: [
      'availableReservoirPredictions',
      {
        resourceName,
      },
    ],
    queryFn: async () => {
      const eventsResponse = await listEvents({
        resourceName,
        filterTypes: [EventType.CONVEYOR_PREDICTION],
      });

      return new ReservoirPredictionsAvailabilityModel(eventsResponse);
    },
  });
